import { k8sRequest, makeK8sCreator } from "../api";
import { formatAge } from "../format";
import { EventRow, K8sEvent, K8sList } from "../types";

const toRow = (event: K8sEvent, index: number): EventRow => {
    const involved = event.involvedObject || {};
    const lastSeen = event.lastTimestamp || event.firstTimestamp || "";

    return {
        // Events have no stable name we can rely on across pages, and the grid
        // needs a unique key, so fall back to position when uid is absent.
        id: event.metadata.uid || `${event.metadata.name}-${index}`,
        type: event.type || "",
        reason: event.reason || "",
        objectKind: involved.kind || "",
        objectName: involved.name || "",
        message: event.message || "",
        count: event.count || 0,
        lastSeen,
        age: formatAge(lastSeen),
    };
};

/**
 * Flatten an EventList, newest first. The API returns events in arbitrary
 * order, and the only useful default for diagnostics is most-recent-first.
 */
export const parseEventList = (body: unknown): EventRow[] => {
    const list = (body || {}) as K8sList<K8sEvent>;

    return (list.items || [])
        .map(toRow)
        .sort((a, b) => (a.lastSeen < b.lastSeen ? 1 : a.lastSeen > b.lastSeen ? -1 : 0));
};

const events = makeK8sCreator<EventRow[]>("k8sEvents", parseEventList);

/**
 * Events for one object, or cluster-wide when no name is given.
 * Kubernetes has no "events for this object" endpoint - it is a field selector
 * over the event list.
 */
const getEventsAction = (involvedObjectName?: string) =>
    events.createThunk(
        k8sRequest(
            "api/v1/events",
            involvedObjectName ? { fieldSelector: `involvedObject.name=${involvedObjectName}` } : undefined
        )
    );

export { getEventsAction };
export const reducer = events.reducer;
